// ShopLogin.jsx
import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";

const baseUrl = config.baseURL;
const PRIMARY_COLOR = "#2E4053";
const ACCENT_COLOR = "#8B4513";

const ShopLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // --- Extract shop from subdomain ---
  const getShopFromSubdomain = () => {
    const host = window.location.hostname; // e.g., shop1.myplatform.com or localhost

    // Local development fallback
    if (host === "localhost" || host === "127.0.0.1") {
      return "test.spadeplatform.com"; // match your DB entry
    }

    // Production: extract subdomain
    const parts = host.split(".");
    if (parts.length >= 3) {
      return parts[0]; // first part is subdomain
    }

    return null; // fallback if subdomain cannot be determined
  };

  const shopSubdomain = getShopFromSubdomain();
  // if (!shopSubdomain) return;
  console.log("Login shopSubdomain:", shopSubdomain);
  if (!shopSubdomain) {
    toast.error(
      "Cannot determine shop from URL. Please use your shop's subdomain."
    );
  }

  const handleLogin = async () => {
    if (!email || !password) {
      toast.error("Please enter email and password.");
      return;
    }
    console.log({ email, password, shopSubdomain });

    setLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/shop/customer/login?shop=${shopSubdomain}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();
      console.log("Login response:", data);

      switch (data.messageId) {
        case 0:
          toast.success(data.message);

          if (!data.token) {
            toast.error("Server did not return a token.");
            return;
          }

          localStorage.setItem("token", data.token);

          // ✅ REDIRECT LOGIC HERE
          const redirect = localStorage.getItem("redirectAfterLogin");

          if (redirect) {
            localStorage.removeItem("redirectAfterLogin");
            navigate(redirect);
          } else {
            navigate("/shop/products");
          }

          break;

        case 1:
          toast.error("Shop subdomain is required.");
          break;
        case 2:
          toast.error("Shop not found.");
          break;
        case 3:
          toast.error("Email and password are required.");
          break;

        case 4:
          toast.error("Invalid credentials.");
          break;
        case -1:
          toast.error("Login failed. Please try again.");
          break;
        default:
          toast.error(data.error || "An unknown error occurred.");
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error(
        err.response?.data?.message || "Login failed. Check your credentials."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F4F6F8",
        fontFamily: "Poppins, sans-serif",
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 400, width: "100%", borderRadius: 3, p: 2 }}>
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
              mb: 3,
              color: PRIMARY_COLOR,
              textAlign: "center",
            }}
          >
            Login to Your Account
          </Typography>

          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          {/* 👇 ADD THIS */}
          <Typography
            sx={{
              mb: 2,
              textAlign: "right",
              fontSize: 14,
              color: PRIMARY_COLOR,
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
            onClick={() => navigate("/shop/forgot-password")}
          >
            Forgot Password?
          </Typography>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: PRIMARY_COLOR,
              color: "#fff",
              py: 1.5,
              fontWeight: 600,
              "&:hover": { backgroundColor: ACCENT_COLOR },
            }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "#fff" }} />
            ) : (
              "Login"
            )}
          </Button>

          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: 14,
              color: "#555",
              cursor: "pointer",
            }}
            onClick={() => navigate("/shop/customerRegister")}
          >
            Don't have an account? Sign Up
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ShopLogin;
